export default __webpack_public_path__ + "static/button-label-dont-39ad5318413335494ddceea1ce7a93bb35f09618d38a0036eeb418727264b4bb.png";